import { FC } from "react"
import { MagicBoxRow } from "shared/components/MagicBoxRow"

const SendProjectCheckbox: FC<{ 
    onClick: () => void, 
    checked: boolean, 
    text: string 
}> = ({ 
    checked, 
    onClick, 
    text  
}) => (
    <MagicBoxRow
        className={'checkbox checkbox-noproject'} 
        checked={checked}
        label={text}
        onClick={onClick}
        isTeamEdit
    />
)

export default SendProjectCheckbox;import { FC } from "react"
import { MagicBoxRow } from "shared/components/MagicBoxRow"

const SendProjectCheckbox: FC<{ 
    onClick: () => void, 
    checked: boolean, 
    text: string 
}> = ({ 
    checked, 
    onClick, 
    text  
}) => (
    <MagicBoxRow
        className={'checkbox checkbox-noproject'} 
        checked={checked}
        label={text}
        onClick={onClick}
        isTeamEdit
    />
)

export default SendProjectCheckbox;